// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"85239117","829":"03d9b7e3","919":"a675e2ee"}[chunkId] + ".chunk.js";
};